import { render, staticRenderFns } from "./storeGoodsManage.vue?vue&type=template&id=4c6e7394&"
import script from "./storeGoodsManage.vue?vue&type=script&lang=js&"
export * from "./storeGoodsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports